document.addEventListener(
  "click",
  function (e) {
    // Firefox: e.target kann ein Text-Node sein
    let t = e.target;
    if (t && t.nodeType === 3) t = t.parentElement; // TEXT_NODE
    if (!t) return;

    const a = t.tagName === "A" ? t : t.closest ? t.closest("a") : null;
    if (!a) return;

    if (a.getAttribute("href") !== "#cookie-settings") return;

    e.preventDefault();

    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === "function") {
      window.privacyBanner.showPreferences();
      return;
    }

    // kleiner Timing-Fallback
    setTimeout(() => window.privacyBanner?.showPreferences?.(), 50);
  },
  true // capture-phase
);